module.exports = __webpack_public_path__ + "media/images/demo_reset-f823855755562e74573c080caa273eda.svg";